import { useEffect, useState } from 'react';

export const useFetch = (url, token) => {
    const [response, setResponse] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    console.log("U :"+ url)

 
    useEffect(() => {
        const myFetch = async() =>{
        setLoading(true);
        const res = await fetch(url, {
            headers: {
             Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          method: 'GET'
            })
            .catch((err) => {
                setError(err)
                setLoading(false)
            });
            
        try{  
          const ans = await res.json();
          setResponse(ans)
        } catch (err) {
          setError(err);
        }
            
        setLoading(false)
        }
        myFetch();    }, [ url ])
    return { response, loading, error }
}